import React, { useContext, useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { promoRecommendation } from 'contexts/PromoRecommendationContext';
import useFetchEventDataList from 'hooks/promoRecommendation/useFetchImportEventData';
import useImportEvent from 'hooks/promoRecommendation/useImportEvent';
import Button from 'components/atoms/Button';
import { CustomModal } from 'CustomComponentCss';
import { CustomSelect } from 'CustomComponentCss';
import DownSvg from 'assets/svg/Down';
import { Spin } from 'antd';
import Loader from 'components/molecules/Loader';

const ImportEventModel = (props: any) => {
    const [selectedImportPlan, setSelectedImportPlan] = useState();
    const [selectedEventIds, setSelectedEventIds] = useState<number[]>([]);
    const [selectAllCheckBox, setSelectAllCheckBox] = useState(false);
    const { selectedPlan, fetchEventsList } = useContext(promoRecommendation);
    const antIcon = <LoadingOutlined style={{ fontSize: 16, color: 'white' }} spin />;
    const eventDataList = props.modifiedPlanData;
    const importDialogBox = props.importDialogBox;
    const setImportDialogBox = props.setImportDialogBox;
    const selectedPlanId = props.selectedPlan;
    const emptyText = 'Select any plan from the above dropdown.';

    const {
        error: eventDataError,
        loading: eventDataLoading,
        data: eventListData,
        setData,
        fetchEventDataList: fetchEventListData,
    } = useFetchEventDataList();

    const { loading, error, data, fetchImportList } = useImportEvent(fetchEventsList, selectedPlan, true);

    function callEventListDataApi(planID: any) {
        fetchEventListData({
            variables: {
                planId: planID,
            },
        });
    }

    function callImportApi() {
        fetchImportList({
            variables: {
                planId: selectedPlanId,
                eventIds: selectedEventIds,
            },
        });
    }

    const handleCancel = () => {
        setImportDialogBox(false);
        setData([]);
        setSelectedEventIds([]);
        setSelectedImportPlan(undefined);
    };

    useEffect(() => {
        if (eventDataList.length) {
            setSelectedImportPlan(eventDataList[0]);
        }
    }, [eventDataList]);

    useEffect(() => {
        if (importDialogBox == true) {
            callEventListDataApi(eventDataList[0].planId);
        }
    }, [importDialogBox]);

    useEffect(() => {
        if (data.importEvents && data.importEvents.operationStatus === 'Success') {
            setImportDialogBox(false);
            setSelectedImportPlan(undefined);
            setSelectedEventIds([]);
            setData([]);
        }
    }, [data]);

    useEffect(() => {
        // Check if all event checkboxes are selected
        const allSelected = eventListData.every((event: any) => selectedEventIds.includes(event.eventId));
        setSelectAllCheckBox(allSelected);
    }, [selectedEventIds]);

    // Import Onclick event for checkbox
    const onClickCheckbox = (eventId: number) => {
        const index = selectedEventIds.indexOf(eventId);
        if (index === -1) {
            setSelectedEventIds([...selectedEventIds, eventId]);
        } else {
            const updatedIds = [...selectedEventIds];
            updatedIds.splice(index, 1);
            setSelectedEventIds(updatedIds);
        }
    };

    // Import Onclick event for select all checkbox
    const onClickOfSelectAll = () => {
        if (selectAllCheckBox) {
            setSelectedEventIds([]);
        } else {
            const allEventIds = eventListData.map((event: any) => event.eventId);
            setSelectedEventIds(allEventIds);
        }
        setSelectAllCheckBox(!selectAllCheckBox);
    };

    //modal footer
    let Footer = () => {
        return (
            <div className="w-full flex justify-end gap-2">
                <Button
                    title={'Reset'}
                    onClick={() => {
                        setSelectedEventIds([]);
                        setSelectAllCheckBox(false);
                    }}
                    style={{ padding: '0px 20px' }}
                    disabled={eventListData.length === 0 || loading || selectedEventIds.length === 0}
                />

                <Button
                    title={
                        loading ? (
                            <div className="flex justify-center items-center">
                                <Spin indicator={antIcon} />
                            </div>
                        ) : (
                            'Import'
                        )
                    }
                    onClick={() => {
                        callImportApi();
                    }}
                    theme={'Solid'}
                    style={{ padding: '0px 20px' }}
                    disabled={eventListData.length === 0 || loading || selectedEventIds.length === 0}
                />
            </div>
        );
    };

    return (
        <CustomModal
            title="Import Events"
            open={importDialogBox}
            width={563}
            onCancel={handleCancel}
            centered
            footer={Footer()}
            maskClosable={false}
        >
            <div className="px-4">
                <div className="flex gap-3 mb-4">
                    <h6 className="mt-1">Plan</h6>
                    <CustomSelect
                        suffixIcon={<DownSvg />}
                        value={selectedImportPlan}
                        options={eventDataList.map((item: any, index: number) => ({
                            ...item,
                            key: index,
                        }))}
                        className="dropdown-height dropdown-width-alt uniqSelPRScenerioDropdown "
                        onChange={(val: any, item: any) => {
                            setSelectedEventIds([]);
                            setSelectedImportPlan(item);
                            callEventListDataApi(item.planId);
                        }}
                        // loading={combinedLoading}
                        // disabled={combinedLoading}
                    />
                </div>
                <div
                    style={{ height: '296px' }}
                    className="border-collapse border border-borderGrey mt-2 mb-4 rounded-t text-purpleFont overflow-auto"
                >
                    <div className="flex w-full justify-between bg-bgBackground border-b-1 border-borderGrey rounded font-medium sticky top-0  z-[100]">
                        <div className="flex w-full cursor-pointer" onClick={onClickOfSelectAll}>
                            <>
                                <div className="flex py-3 px-3">
                                    {eventListData.length > 0 && !eventDataLoading ? (
                                        <input
                                            type={'checkbox'}
                                            className={'cursor-pointer checkbox-size accent-purpleFont'}
                                            checked={selectAllCheckBox && selectedEventIds.length > 0}
                                        />
                                    ) : null}
                                </div>
                                <div className="flex py-2">
                                    {eventListData.length > 0 && !eventDataLoading ? <span>Select Events</span> : null}
                                </div>
                            </>
                        </div>
                    </div>
                    <div className="flex w-full justify-between flex-col">
                        {eventListData.length === 0 || eventDataLoading ? (
                            <div style={{ marginTop: '110px' }} className="flex justify-center items-center h-900">
                                <div className="flex font-md text-borderGrey  justify-center items-center">
                                    {eventListData.length === 0 && !selectedImportPlan ? (
                                        emptyText
                                    ) : eventDataLoading ? (
                                        <Loader />
                                    ) : (
                                        'No Events Found.'
                                    )}
                                </div>
                            </div>
                        ) : (
                            eventListData.map((item: any, index: any) => (
                                <div
                                    style={{ height: '43px' }}
                                    className="flex justify-between w-full items-center border-solid border-0 border-t border-borderGrey p-2 !text-fontGray"
                                    key={index}
                                >
                                    <div
                                        className="flex w-full cursor-pointer"
                                        onClick={() => onClickCheckbox(item.eventId)}
                                    >
                                        <div className="flex py-1 mt-1 px-1 ">
                                            <input
                                                type={'checkbox'}
                                                className={'cursor-pointer checkbox-size accent-purpleFont'}
                                                checked={selectedEventIds.includes(item.eventId)}
                                            />
                                        </div>
                                        <div
                                            className="font-xxs py-2 pl-2 !text-fontGray w-full min-w-40 font-medium"
                                            style={{
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {item.eventName}
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </CustomModal>
    );
};

export default ImportEventModel;
